let moengageInstance = null;
let isMoengageInitialized = false;

/**
 * Internal function to create the MoEngage instance.
 */
const createMoengageInstance = () => {
    const env = process.env.REACT_APP_ENV || "prod";
    const debugLogs = env === "uat" ? 1 : 0;

    return window.moe({
        app_id: "L9SUGRVWTLEJA9UWH2ZEAMHL",
        debug_logs: debugLogs,
    });
};

/**
 * Initializes the MoEngage SDK synchronously.
 */
export const initializeMoengage = () => {
    if (!isMoengageInitialized || !moengageInstance) {
        try {
            moengageInstance = createMoengageInstance();
            isMoengageInitialized = true;
        } catch (err) {
            console.error("MoEngage SDK initialization failed", err);
            moengageInstance = null;
            isMoengageInitialized = false;
        }
    }

    return moengageInstance;
};

/**
 * Gets the MoEngage instance.
 * If not initialized, initializes it on the spot and returns it.
 */
export const getMoengage = () => {
    if (!isMoengageInitialized || !moengageInstance) {
        console.warn("MoEngage is not initialized. Initializing now...");
        return initializeMoengage();
    }

    return moengageInstance;
};